import React from 'react'
import GenerateIcon from './GenerateIcon'
import { Button } from '@mui/material'
import { Link } from 'react-router-dom'

interface IProps {
    title?: string,
    message?: string,
    hideButton?: boolean,
}

export default function OnlyAuthorizedMessage(props: IProps) {

    const { title, message, hideButton } = props

    return(
        <div className="only-authorized-message-box">
            <div className="content-of-only-authorized-message-box">

                <div className="icon-box-of-only-authorized-message-box">
                    <div className="content-of-icon-box-of-only-authorized-message-box">
                        <GenerateIcon icon="warning" />
                    </div>
                </div>

                <div className="text-box-of-only-authorized-message-box">
                    <div className="content-of-text-box-of-only-authorized-message-box">
                        <h3>{title ? title : "Unauthorized"}</h3>
                        <p>{message ? message : "You must sign-in to your account to access all the features"}</p>
                    </div>
                </div>

                {!hideButton && (
                    <div className="button-box-of-only-authorized-message-box">
                        <div className="content-of-button-box-of-only-authorized-message-box">
                            <Link to={`/sign-in?back=${window.location.pathname + window.location.search}`}>
                                <Button className="general-button" variant="outlined">
                                    Sign-in
                                </Button>
                            </Link>
                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}